import React, { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormLimiteCredito, Select } from '~/pages/RegraDeEmpresa/protocols';
import api from '~/services/api';

import { useRegraEmpresa } from '~/pages/RegraDeEmpresa/RegraDeEmpresaContext';
import { Container } from './styles';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { InputMoney, InputSelect } from '~/components/NovosInputs';
import { toast } from 'react-toastify';
import { formatCurrencyBR } from '~/utils/functions';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const MySwal = withReactContent(Swal);
export const Form: React.FC = () => {
  const [finalizadorasAtivas, setfinalizadorasAtivas] = useState<Select[]>([]);

  const {
    formRegraEmpresa,
    handleFormRegraEmpresa,
    formLimiteCredito,
    handleFormLimiteCredito,
    handleClearFormLimite,
    isEdit,
    setIsEdit,
    editingId,
    setEditingId,
    formTela: { setValue, register, control, getValues },
  } = useRegraEmpresa();

  async function getfinalizadoras(cod_grupo: string | number | undefined) {
    const res = await api.get(`/regraempresa/finalizadora/${cod_grupo}`);
    const { data } = res.data;

    const regsAtivas = data
      .filter((reg: any) => reg.flg_inativa !== true)
      .filter(
        (reg: any, index: number, self: any[]) =>
          index ===
          self.findIndex((r) => r.cod_finalizadora === reg.cod_finalizadora),
      )
      .map((reg: any) => ({
        value: reg.cod_finalizadora,
        label: reg.des_finalizadora,
        des_finalizadora: reg.des_finalizadora,
      }));

    setfinalizadorasAtivas(regsAtivas);
  }

  useEffect(() => {
    const cod_grupo = formRegraEmpresa.cod_grupo_empresa.value.value;
    if (cod_grupo) {
      getfinalizadoras(cod_grupo);
    }
  }, [formRegraEmpresa.cod_grupo_empresa.value.value]);

  const onAddFinalizadoraLoja = async () => {
    if (!getValues('cod_finalizadora')?.value || !getValues('val_limite')) {
      toast.warning(
        'Necessário informar valores para "Finalizadora" e "Valor Unit."',
      );
      return;
    }

    const formattedValLimite = formatCurrencyBR(
      formLimiteCredito?.val_limite?.value || 0,
    );
    const payload: FormLimiteCredito = {
      ...formLimiteCredito,
      val_limite: {
        ...formLimiteCredito.val_limite,
        value: formattedValLimite,
        isInvalid: parseFloat(formattedValLimite) === 0,
      },
    };

    const currentId = payload.cod_finalizadora.value.value;

    // == MODO EDIÇÃO: substitui o registro pelo editingId ==
    if (isEdit) {
      const originalId = editingId ?? currentId;

      // Se o usuário trocou a finalizadora para uma que já existe (diferente do original),
      // peça confirmação para substituir a existente.
      const duplicate = formRegraEmpresa.Limites.limites.find(
        (l) =>
          l.cod_finalizadora.value.value === currentId &&
          l.cod_finalizadora.value.value !== originalId,
      );

      if (duplicate) {
        const { isConfirmed } = await MySwal.fire({
          title: '',
          text: 'Esta finalizadora já existe. Deseja substituir a existente por este novo valor?',
          showCancelButton: true,
          confirmButtonColor: '#07289e',
          cancelButtonColor: '#ff7b7b',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
        });
        if (!isConfirmed) return;

        // Remove duplicada e o item original, insere o payload
        const data = [
          ...formRegraEmpresa.Limites.limites.filter(
            (l) =>
              l.cod_finalizadora.value.value !== originalId &&
              l.cod_finalizadora.value.value !== currentId,
          ),
          payload,
        ];

        setValue('limites', data);
        handleFormRegraEmpresa({
          ...formRegraEmpresa,
          Limites: { ...formRegraEmpresa.Limites, limites: data },
        });
      } else {
        // Substitui apenas o item cujo id == originalId
        const data = formRegraEmpresa.Limites.limites.map((l) =>
          l.cod_finalizadora.value.value === originalId ? payload : l,
        );

        setValue('limites', data);
        handleFormRegraEmpresa({
          ...formRegraEmpresa,
          Limites: { ...formRegraEmpresa.Limites, limites: data },
        });
      }

      setIsEdit(false);
      setEditingId(null);
      return handleClearFormLimite();
    }

    // == MODO INSERÇÃO ==
    const hasExist = formRegraEmpresa.Limites.limites.find(
      (l) => l.cod_finalizadora.value.value === currentId,
    );

    if (hasExist) {
      const { isConfirmed } = await MySwal.fire({
        title: '',
        text: 'Finalizadora já informada, deseja substituir a mesma?',
        showCancelButton: true,
        confirmButtonColor: '#07289e',
        cancelButtonColor: '#ff7b7b',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
      });

      if (!isConfirmed) return;

      const data = formRegraEmpresa.Limites.limites.map((l) =>
        l.cod_finalizadora.value.value === currentId ? payload : l,
      );

      setValue('limites', data);
      handleFormRegraEmpresa({
        ...formRegraEmpresa,
        Limites: { ...formRegraEmpresa.Limites, limites: data },
      });
      return handleClearFormLimite();
    }

    // inserir novo
    const data = [...formRegraEmpresa.Limites.limites, payload];
    setValue('limites', data);
    handleFormRegraEmpresa({
      ...formRegraEmpresa,
      Limites: { ...formRegraEmpresa.Limites, limites: data },
    });
    setIsEdit(false);
    setEditingId(null);
    return handleClearFormLimite();
  };

  const onClearForm = () => {
    setIsEdit(false);
    handleClearFormLimite();
  };

  return (
    <Row>
      <Col sm={12} md={4}>
        <InputSelect
          label="Finalizadora"
          placeholder="- Selecione a Finalizadora -"
          name="cod_finalizadora"
          register={register}
          isError={false}
          control={control}
          options={finalizadorasAtivas as any[]}
          changeSelected={(value: any) => {
            setValue('cod_finalizadora', value);

            handleFormLimiteCredito({
              ...formLimiteCredito,
              cod_finalizadora: {
                ...formLimiteCredito.cod_finalizadora,
                value,
                isInvalid: value.value === undefined,
              },
              des_finalizadora: {
                ...formLimiteCredito.des_finalizadora,
                value: value.des_finalizadora,
              },
            });
            document.getElementById('val_limite')?.focus();
          }}
        />
      </Col>
      <Col sm={12} md={3}>
        <InputMoney
          id="val_limite"
          label="Valor Unit."
          min={0}
          decimals={2}
          placeholder="0,00"
          showIcon
          name="val_limite"
          isError={false}
          register={register}
          control={control}
          disabled={false}
          onInput={(ev: ChangeEvent<HTMLInputElement>) => {
            const { value } = ev.target;

            setValue('val_limite', formatCurrencyBR(value));
            handleFormLimiteCredito({
              ...formLimiteCredito,
              val_limite: {
                ...formLimiteCredito.val_limite,
                value,
                isInvalid: parseFloat(formatCurrencyBR(value)) === 0,
              },
            });
          }}
        />
      </Col>
      <Col sm={12} md={5} className="Buttoons">
        <Container>
          <CustomButtonNovo
            onClick={async () => {
              await onAddFinalizadoraLoja();
            }}
            variant="confirm"
            label="Confirmar"
          />

          <CustomButtonNovo
            onClick={onClearForm}
            variant="clear"
            label="Limpar"
          />
        </Container>
      </Col>
    </Row>
  );
};
